/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { State } from '@gh/common-shared';
import { FocusedCell } from '@gh/core-ui-grid';
import { isNil } from 'lodash';
import { Observable } from 'rxjs';
import { isJeContractPriceTop, JeTop } from '../../../resources/job-estimate-details.model';
import { JeCommandService } from '../je-command.service';
import {
  JeDetailsState,
  JeFocusedTable,
  queryJeEditable,
  queryJeFocusedCell,
  queryJeProcessChangesAsap,
  queryJeTops,
} from '../je-details.state';
import { JeDetailsTopGridDefinition } from './je-details-top-grid-definition.service';

@Component({
  standalone: false,
  selector: 'gh-je-details-top-list',
  templateUrl: 'je-details-top-list.component.html',
  styleUrls: ['je-details-top-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [JeDetailsTopGridDefinition],
})
export class JeDetailsTopListComponent implements OnInit {
  editable$: Observable<boolean>;
  tops$: Observable<JeTop[]>;
  focusedCell$: Observable<Maybe<FocusedCell>>;
  processChangesAsap$: Observable<boolean>;

  constructor(public gridDefinition: JeDetailsTopGridDefinition,
              private state: State<JeDetailsState>,
              private commands: JeCommandService) {

  }

  ngOnInit(): void {
    this.tops$ = this.state.select(queryJeTops);
    this.focusedCell$ = this.state.select(queryJeFocusedCell, JeFocusedTable.TopList);
    this.editable$ = this.state.select(queryJeEditable);
    this.processChangesAsap$ = this.state.select(queryJeProcessChangesAsap);
  }

  canBeDeleted(top: JeTop): boolean {
    if (isJeContractPriceTop(top)) {
      return false;
    }

    return isNil(top.count) || top.count === 0;
  }

  onOpenGto(): void {
    this.commands.openGto();
  }

  onViewInfo(top: JeTop): void {
    this.commands.topViewInfo(top);
  }

  onDelete(top: JeTop): void {
    this.commands.topRemove(top);
  }

  onFocusedCellChanged(): void {
    this.commands.resetFocusedCell();
  }
}
